module.exports = __webpack_public_path__ + "crusa.png?68021485693f1c16f8a5b44aec9700f5";